export const TYPEAHEAD = "/api/TypeaheadSearch/TypeaheadSearch?&query="
export const SEARCHPAGE = "/search/"
export const SITE_PREFIX = ""
